'use client';

import { useForgotPassword } from '@/modules/authentication/application';

import { useToast } from '@packages/web-design-systems';

import { mapForgotPasswordFormToDto } from '../mappers';
import type { ForgotPasswordFormModel } from '../models/forgot-password.form-model';

export const useForgotPasswordForm = () => {
	const { submit } = useForgotPassword();
	const { showError, showSuccess } = useToast();

	const execute = async (form: ForgotPasswordFormModel) => {
		const forgotPasswordDto = mapForgotPasswordFormToDto(form);
		const result = await submit(forgotPasswordDto);

		return result.isFailure
			?  showError({ title: 'There was an error submitting the form. Please try again later.' })
			:  showSuccess({ title: 'If the email is registered, you will receive password reset instructions shortly.' });
	};

	return { execute };
};
